export default class NoYesModel {
    public no: number = 0;
    public yes: number = 0;
}